import React, { Component } from 'react';
import { ghostedDocks } from '../../../../Game/GamePlayerInfo';
import { availableDocksForGhost } from '../../../Common/CardUtilities';


export default class AddGhost2d extends Component {

    componentDidMount() {
        this.highlightDockChoices();
        window.addEventListener(
            'hotel-interface-mounted-event', this.mountedEvent);
    }

    mountedEvent = () => {
        this.highlightDockChoices();
    }

    highlightDockChoices = () => {
        const docks = availableDocksForGhost(this.props.gamePlayerData.docks);
        window.dispatchEvent(
            new CustomEvent('highlight-docks-event',
                {
                    detail: {
                        highlightedDocks: docks,
                        callback: this.onClick
                    }
                }));
    }

    onClick = (dockIndex) => {
        this.props.app.game.seatedController.gamePlayerApi.placeGhost(dockIndex);
        window.dispatchEvent(new Event('clear-docks-highlight-event'));
        window.removeEventListener(
            'hotel-interface-mounted-event', this.mountedEvent);
    }


    componentWillUnmount() {
        window.dispatchEvent(new Event('clear-docks-highlight-event'));
        window.removeEventListener(
            'hotel-interface-mounted-event', this.mountedEvent);
    }

    render() {
        return <></>;
    }

}
